import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { ButtonV2 } from 'src/components/general/button/lgg-button';
import { CloseConfirmationModal } from 'src/components/general/feedback/hooks/use-show-confirmation-modal';
import { FlexRow } from 'src/components/layout/flex-row';
import { useBreakpoint } from 'src/hooks/use-breakpoint';

export const useConfirmationModalSize = () => {
  const breakpointUpMd = useBreakpoint(up('md'));

  return useMemo(
    () => (breakpointUpMd ? { maxWidth: 540, width: '540px' } : {}),
    [breakpointUpMd],
  );
};

export const ConfirmationModalTitle = styled.span`
  line-height: 30px;
`;

export const ConfirmationModalMessage = styled.div`
  line-height: 22px;

  p {
    margin: 0;
  }

  p + p {
    margin-top: 24px;
  }
`;

const FooterButtons = styled(FlexRow)`
  gap: 10px;
`;

const FooterButton = styled(ButtonV2)`
  ${up('md')} {
    height: 32px;
  }
`;

export const ConfirmationModalDeleteFooter = ({
  confirmLabel,
  onConfirm,
  onClose,
}: {
  confirmLabel: string;
  onConfirm: VoidFunction;
  onClose: CloseConfirmationModal;
}) => {
  const { t } = useTranslation(['common']);
  const breakpointUpMd = useBreakpoint(up('md'));
  const size = breakpointUpMd ? 'small' : 'regular';

  return (
    <FooterButtons>
      <FooterButton
        data-lgg-id="confirmation-modal-cancel-button"
        variant="default"
        size={size}
        onClick={() => onClose()}
      >
        {t('common:cancel')}
      </FooterButton>
      <FooterButton
        data-lgg-id="confirmation-modal-confirm-button"
        variant="delete"
        size={size}
        onClick={() => {
          onConfirm();
          onClose({ isSuccess: true });
        }}
      >
        {confirmLabel}
      </FooterButton>
    </FooterButtons>
  );
};
